import util from '@bmp-vue/core/api/util'
import Axios from 'axios'
const controller = 'Ticket'
export default Object.assign({}, util.GetCrud(controller, null), {
  GetByOperacao: function (codigoOperacao, vm) {
    return Axios.get(
      process.env.VUE_APP_ROOT_API + 'Ticket/GetByOperacao/' + codigoOperacao,
      {
        headers: { Authorization: `Bearer ${vm.$user.token}` }
      }
    ).then(function (p) {
      return p.data
    })
  },
  GetLastTicketByDocumento () {
    return util.Axios.Get(controller + '/GetLastTicketByDocumento')
  },
  EnviarAnalise (id, dto) {
    return util.Axios.Put(controller + '/EnviarAnalise', id, dto)
  },
  VerificaRetornoTicket (codigoOperacao) {
    return util.Axios.Post(controller + '/VerificaRetornoTicket/' + codigoOperacao)
  }
})
